(function (angular) {
  'use strict';

  angular.module('risevision.common.components.store-products', [
    'truncate',
    'slugifier',
    'risevision.store.product'
  ]);

})(angular);
